const tennisData = [
    {
      id: 1,
      alt:'gallery image',
      img:'/assets/images/section/tennis/T1.jpg',
    },
    {
      id: 2,
      alt:'gallery image',
      img:'/assets/images/section/tennis/T2.jpg',
    },
    {
      id: 3,
      alt:'gallery image',
      img:'/assets/images/section/tennis/T3.jpg',
    },
    {
      id: 4,
      alt:'gallery image',
      img:'/assets/images/section/tennis/T4.jpg',
    },
    {
      id: 5,
      alt:'gallery image',
      img:'/assets/images/section/tennis/T5.jpg',
    },
    {
      id: 6,
      alt:'gallery image',
      img:'/assets/images/section/tennis/T6.jpg',
    },
     {
      id:8,
      alt:'gallery image',
      img:'/assets/images/section/tennis/t8.jpg',
    },
     {
      id: 9,
      alt:'gallery image',
      img:'/assets/images/section/tennis/t9.jpg',
    },
     {
      id: 10,
      alt:'gallery image',
      img:'/assets/images/section/tennis/t10.jpg',
    },
     {
      id: 11,
      alt:'gallery image',
      img:'/assets/images/section/tennis/t11.jpg',
    },
     {
      id: 12,
      alt:'gallery image',
      img:'/assets/images/section/tennis/t12.jpg',
    },
     {
      id: 13,
      alt:'gallery image',
      img:'/assets/images/section/tennis/t13.jpg',
    },
     {
      id: 14,
      alt:'gallery image',
      img:'/assets/images/section/tennis/t14.jpg',
    },
     {
      id: 15,
      alt:'gallery image',
      img:'/assets/images/section/tennis/t15.jpg',
    },
  ];

  export default tennisData;